module.exports = "/_next/static/images/ic_token-6571c304d4a1dd383b14e2c66afde9a5.png";